// const prodConfig = {
// apiKey           : "YOUR_API_KEY",
// authDomain       : "your-app.firebaseapp.com",
// databaseURL      : "https://your-app.firebaseio.com",
// projectId        : "your-app",
// storageBucket    : "your-app.appspot.com",
// messagingSenderId: "YOUR_MESSAGING_SENDER_ID"
// };

const prodConfig = {
	apiKey: "AIzaSyD1ccAYGFZPx9boIP-fkL4boSRdE9FbwpI",
	authDomain: "runningman-31b2d.firebaseapp.com",
	databaseURL: "https://runningman-31b2d-default-rtdb.firebaseio.com",
	projectId: "runningman-31b2d",
	storageBucket: "runningman-31b2d.appspot.com",
	messagingSenderId: "61742975894",
	appId: "1:61742975894:web:f4510db53f651166a46bb7",
	measurementId: "G-B47EZ0GZL0",
};
const devConfig = {
	apiKey: "AIzaSyD1ccAYGFZPx9boIP-fkL4boSRdE9FbwpI",
	authDomain: "runningman-31b2d.firebaseapp.com",
	databaseURL: "https://runningman-31b2d-default-rtdb.firebaseio.com",
	projectId: "runningman-31b2d",
	storageBucket: "runningman-31b2d.appspot.com",
	messagingSenderId: "61742975894",
	appId: "1:61742975894:web:f4510db53f651166a46bb7",
	measurementId: "G-B47EZ0GZL0",
};

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

export default config;
